import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { auth } from "@/lib/auth";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      auth.setToken(data.token);
      toast.success("Welcome back, James.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-charcoal text-warmwhite flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-baseline gap-2 mb-12">
          <span className="font-serif text-3xl">James</span>
          <span className="font-serif italic text-gold text-2xl">1:1</span>
        </Link>
        <div className="border border-warmwhite/15 p-10">
          <div className="flex items-center gap-3 mb-2">
            <Lock className="w-4 h-4 text-gold" strokeWidth={1.5} />
            <p className="text-[11px] uppercase tracking-widest-custom text-warmwhite/60">Admin</p>
          </div>
          <h1 className="font-serif text-3xl md:text-4xl font-light leading-tight">Sign in to the studio.</h1>

          <form onSubmit={submit} className="mt-10 space-y-6" data-testid="admin-login-form">
            <div>
              <label className="text-[10px] uppercase tracking-widest-custom text-warmwhite/55">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full bg-transparent border-b border-warmwhite/40 focus:border-gold outline-none py-2 font-serif text-lg" data-testid="admin-login-email" />
            </div>
            <div>
              <label className="text-[10px] uppercase tracking-widest-custom text-warmwhite/55">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full bg-transparent border-b border-warmwhite/40 focus:border-gold outline-none py-2 font-serif text-lg" data-testid="admin-login-password" />
            </div>
            <button type="submit" disabled={busy} className="w-full bg-gold text-charcoal px-8 py-4 text-[11px] uppercase tracking-widest-custom hover:bg-warmwhite transition-colors disabled:opacity-60" data-testid="admin-login-submit">
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
